var $b75ee270c131bbcf$exports = {};
$b75ee270c131bbcf$exports = {
    "maximum": `\u{623}\u{642}\u{635}\u{649}`,
    "minimum": `\u{623}\u{62F}\u{646}\u{649}`
};


export {$b75ee270c131bbcf$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
